import React, { useState } from 'react';
import { Card, Avatar, Button, Typography, Form, Input, Modal } from 'antd';
import AppFooter from '../../components/Footer'; 
import AppHeader from '../../components/Header';
import './index.css';

const { Title, Text } = Typography;

const ProfilePage = () => {
  const [userInfo, setUserInfo] = useState({
    avatar: '',
    name: '',
    introduction: '这个人很神秘，什么也没留下。',
    description: '欢迎来到我的博客！请登陆后完善您的个人信息！',
    email: '',
    techStack: '暂无',
    hobbies: '暂无',
    github: '#',
    personalWebsite: '#'
  });

  const [isEditing, setIsEditing] = useState(false);

  const [form] = Form.useForm();

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  const handleSubmit = (values) => {
    setUserInfo({
      avatar: values.avatar,
      name: values.name,
      introduction: values.introduction,
      description: values.description,
      email: values.email,
      techStack: values.techStack,
      hobbies: values.hobbies,
      github: values.github,
      personalWebsite: values.personalWebsite,
    });
    setIsEditing(false);
  };

  return (
    <div style={{ padding: '20px', backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
      <AppHeader />
      <Card
        style={{
          width: '80%',
          maxWidth: '800px',
          margin: 'auto',
          borderRadius: '12px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          backgroundColor: '#ffffff',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <Avatar
            size={100}
            src={userInfo.avatar}
            style={{ marginBottom: '10px' }}
          />
          <Title level={2} style={{ margin: '0' }}>
            Hi，我是 {userInfo.name}！
          </Title>
          <Text type="secondary" style={{ marginTop: '10px' }}>
            {userInfo.introduction}
          </Text>
          <Text type="secondary" style={{ display: 'block', marginTop: '10px' }}>
            {userInfo.description}
          </Text>
        </div>

        {/* 个人信息卡片 */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
          {/* 左侧信息列 */}
          <div style={{ flex: 1, minWidth: '200px' }}>
            <div style={{ marginBottom: '15px' }}>
              <Text strong>邮箱</Text>
              <Text type="secondary" style={{ marginLeft: '10px' }}>
                {userInfo.email}
              </Text>
            </div>
            <div style={{ marginBottom: '15px' }}>
              <Text strong>技术栈</Text>
              <Text type="secondary" style={{ marginLeft: '10px' }}>
                {userInfo.techStack}
              </Text>
            </div>
            <div style={{ marginBottom: '15px' }}>
              <Text strong>兴趣爱好</Text>
              <Text type="secondary" style={{ marginLeft: '10px' }}>
                {userInfo.hobbies}
              </Text>
            </div>
          </div>

          {/* 右侧空白区域 */}
          <div style={{ flex: 1, minWidth: '200px' }}></div>
        </div>

        {/* 编辑按钮 */}
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <Button type="primary" onClick={handleEditClick}>
            编辑个人信息
          </Button>
        </div>

        {/* 编辑模态框 */}
        <Modal
          title="编辑个人信息"
          open={isEditing}
          onCancel={handleCancel}
          onOk={() => {
            form.submit();
          }}
          footer={[
            <Button key="cancel" onClick={handleCancel}>
              取消
            </Button>,
            <Button key="submit" type="primary" onClick={() => form.submit()}>
              确定
            </Button>,
          ]}
        >
          <Form
            form={form}
            layout="vertical"
            initialValues={userInfo}
            onFinish={handleSubmit}
          >
            <Form.Item
              name="avatar"
              label="头像 (URL)"
              rules={[{ required: true, message: '请输入头像链接' }, { type: 'url', message: '请输入有效的URL' }]}
            >
              <Input placeholder="请输入头像链接" />
            </Form.Item>

            <Form.Item
              name="name"
              label="姓名"
              rules={[{ required: true, message: '请输入姓名' }]}
            >
              <Input placeholder="请输入姓名" />
            </Form.Item>

            <Form.Item
              name="introduction"
              label="个人简介"
              rules={[{ required: true, message: '请输入个人简介' }]}
            >
              <Input.TextArea placeholder="请输入个人简介" rows={3} />
            </Form.Item>

            <Form.Item
              name="description"
              label="更详细的介绍"
              rules={[{ required: true, message: '请输入更详细的介绍' }]}
            >
              <Input.TextArea placeholder="请输入更详细的介绍" rows={4} />
            </Form.Item>

            <Form.Item
              name="email"
              label="联系邮箱"
              rules={[{ required: true, message: '请输入联系邮箱' }, { type: 'email', message: '请输入有效的邮箱' }]}
            >
              <Input placeholder="请输入联系邮箱" />
            </Form.Item>

            <Form.Item
              name="techStack"
              label="技术栈"
            >
              <Input placeholder="请输入技术栈" />
            </Form.Item>

            <Form.Item
              name="hobbies"
              label="兴趣爱好"
            >
              <Input placeholder="请输入兴趣爱好" />
            </Form.Item>

            <Form.Item
              name="github"
              label="GitHub 链接"
            >
              <Input placeholder="请输入GitHub链接" />
            </Form.Item>

            <Form.Item
              name="personalWebsite"
              label="个人主页链接 (可选)"
            >
              <Input placeholder="请输入个人主页链接" />
            </Form.Item>
          </Form>
        </Modal>
      </Card>
      <AppFooter />
    </div>
  );
};

export default ProfilePage;